import React from 'react';
interface FooterProps {
  onOpenModal: (modalName: string) => void;
}
export const Footer: React.FC<FooterProps> = ({
  onOpenModal
}) => {
  return <footer className="bg-gray-900 text-white py-8 px-4 sm:px-6 lg:px-8" data-id="element-197">
      <div className="max-w-7xl mx-auto" data-id="element-198">
        <div className="flex flex-col items-center text-center" data-id="element-199">
          <div className="mb-4" data-id="element-200">
            <p className="text-sm text-gray-400" data-id="element-201">
              © {new Date().getFullYear()} Recetario Fit para Airfryer. Todos
              los derechos reservados.
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6" data-id="element-202">
            <button onClick={() => onOpenModal('terms')} className="text-sm text-gray-400 hover:text-white transition duration-200" data-id="element-203">
              Términos y Condiciones
            </button>
            <button onClick={() => onOpenModal('privacy')} className="text-sm text-gray-400 hover:text-white transition duration-200" data-id="element-204">
              Política de Privacidad
            </button>
            <button onClick={() => onOpenModal('contact')} className="text-sm text-gray-400 hover:text-white transition duration-200" data-id="element-205">
              Contacto
            </button>
          </div>
        </div>
      </div>
    </footer>;
};